import React from 'react';
import { Link } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import logo from '../../logo192.png';
import { LINKS, openExternalLink } from '../../config/links';
import { colors } from '../../styles/theme';

function Footer() {
  return (
    <footer className={css(styles.footer)}>
      <div className={css(styles.inner)}>
        <div className={css(styles.top)}>
          <div className={css(styles.brand)}>
            <span className={css(styles.logoWrap)}>
              <img src={logo} alt="YaBatho Logo" className={css(styles.logo)} />
            </span>
            <span>
              <strong className={css(styles.brandTitle)}>YaBatho</strong>
              <span className={css(styles.brandText)}>
                Local food, local people, delivered together.
              </span>
            </span>
          </div>

          <nav className={css(styles.links)} aria-label="Footer navigation">
            <Link className={css(styles.link)} to="/customers">Customers</Link>
            <Link className={css(styles.link)} to="/restaurants">Restaurants</Link>
            <Link className={css(styles.link)} to="/riders">Riders</Link>
            <Link className={css(styles.link)} to="/about">About</Link>
            <Link className={css(styles.link)} to="/contact">Contact</Link>
            <button
              className={css(styles.linkButton)}
              onClick={() => openExternalLink(LINKS.adminDashboard)}
            >
              Admin
            </button>
          </nav>
        </div>

        <div className={css(styles.bottom)}>
          <p className={css(styles.copy)}>
            © {new Date().getFullYear()} YaBatho. All rights reserved.
          </p>
          <p className={css(styles.copy)}>
            Developed by C Digital &amp; LPTB Solutions.
          </p>
        </div>
      </div>
    </footer>
  );
}

const styles = StyleSheet.create({
  footer: {
    borderTop: `1px solid ${colors.border}`,
    padding: '38px 24px 24px',
    backgroundColor: colors.ink,
    width: '100%',
    boxSizing: 'border-box',
  },
  inner: {
    width: '100%',
    maxWidth: '1280px',
    margin: '0 auto',
  },
  top: {
    display: 'grid',
    gridTemplateColumns: 'minmax(260px, 1fr) auto',
    gap: '40px',
    alignItems: 'center',
    paddingBottom: '30px',
    '@media (max-width: 760px)': {
      gridTemplateColumns: '1fr',
      gap: '28px',
      alignItems: 'flex-start',
    },
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  logoWrap: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    backgroundColor: colors.sand,
    border: `1px solid ${colors.gold}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  logo: {
    width: '36px',
    height: '36px',
    objectFit: 'contain',
  },
  brandTitle: {
    display: 'block',
    color: colors.white,
    fontWeight: '900',
    fontSize: '1.08rem',
  },
  brandText: {
    display: 'block',
    color: colors.goldSoft,
    fontSize: '0.84rem',
    marginTop: '3px',
    lineHeight: 1.5,
  },
  links: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, auto)',
    gap: '13px 24px',
    '@media (max-width: 760px)': {
      width: '100%',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
  },
  link: {
    color: colors.white,
    textDecoration: 'none',
    fontWeight: '900',
    fontSize: '0.9rem',
  },
  linkButton: {
    border: 'none',
    backgroundColor: 'transparent',
    color: colors.white,
    fontWeight: '900',
    fontSize: '0.9rem',
    cursor: 'pointer',
    padding: 0,
    textAlign: 'left',
  },
  bottom: {
    paddingTop: '20px',
    borderTop: '1px solid rgba(230, 216, 190, 0.3)',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px 24px',
    flexWrap: 'wrap',
    '@media (max-width: 560px)': {
      display: 'grid',
      gridTemplateColumns: '1fr',
    },
  },
  copy: {
    margin: 0,
    color: colors.goldSoft,
    fontSize: '0.78rem',
    lineHeight: 1.5,
  },
});

export default Footer;
